module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "chap-title"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("The Oaks (Ardsley Main) Colliery and 1847 Explosion")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The land was owned by Richard Micklethwaite of Ardsley and the first colliery shaft was sunk in 1824. Deeper shafts were sunk in 1838/9 at great expense to reach the Barnsley Seam. By 1847, Ardsley Main Colliery was owned by William Micklethwaite and let to Messrs Firth Barber & Company. Repairs and structural alterations were carried out after the 1847 explosion and another shaft was sunk. Ardsley Main became the Oaks by 1851, known as the Old Oaks after the 1866 explosion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The mine was renowned for having areas where inflammable gas (firedamp or methane) accumulated and, while workers were not supposed to use naked flames nearby, this was not adequately enforced and the Oaks Colliery was notorious for its number of accidents.")]), _vm._v(" "), _c('h4', {
    staticClass: "sub_level"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Explosion on Friday 5 March 1847")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Owing to the depth of the coal seam being worked, the Oaks Colliery had two shafts, one that was used for winding men, boys, and materials, and the other for ventilation. A fire had damaged the headgear of the ventilation shaft on 4 December 1845 and repair work was underway there in March 1847. The terrific explosion occurred at about 3pm, when the ninety-five men and boys working underground or in the air shaft were approaching the end of their shift.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Reports in contemporary newspapers described vividly the huge explosion that ‘shook the whole neighbourhood like an earthquake … a blaze of fire arose from the pit to a considerable height above the head-gearing and was followed by a dense body of sulphurous smoke’, ‘resembling the eruption of a volcano’, ‘smoke, dust, bricks, coals and timber were thrown up into the air from the mouth of the pit, to the height of 30 or 40 yards’. ‘Frantic wives and weeping children’ rushed towards the pit head, to be joined by thousands of people from Barnsley and surrounding villages in addition to miners from miles around who wanted to ‘render assistance to their unfortunate brethren.’ They had to wait to descend until it was assessed as safe and the partition between the two air shafts had been rebuilt.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0021-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("The explosion and the pit head in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Illustrated London News")]), _vm._v(". (Courtesy of Barnsley Archives)")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the time, this was one of the biggest colliery disasters in the country with its huge loss of life. Seventy-three victims were killed either by ‘choke damp’ (a suffocating gas, usually carbon dioxide) or burns and injuries resulting from the explosion. There were thirty-one boys, aged from 10 to 18, and forty-two men, the oldest of whom was 50. Several families lost more than one member.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some detailed accounts of the tragedy published in newspapers included gruesome details of the miners trapped underground, the escape of some survivors and the difficult recovery of the bodies, many ‘scarcely identifiable’ because of burns. It had a huge impact on families involved and their community because they knew each other well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The names of twelve of the nineteen survivors were mentioned and some of them, plus Michael Haigh, were connected to victims or referred to by the Colliers Relief Committee (underlined):")]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("William Ayre")])]), _vm._v(" "), _c('td', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Edward Burrows")])])]), _vm._v(" "), _c('td', {
    staticClass: "border1"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("William Charlesworth")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("William Cooke")])])]), _vm._v(" "), _c('td', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("William Drury")])]), _vm._v(" "), _c('td', {
    staticClass: "border1"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("William Hare")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("William Hewitt")])]), _vm._v(" "), _c('td', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Bernard Morgan")])]), _vm._v(" "), _c('td', {
    staticClass: "border1"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("William Peach")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Joseph Simonds")])]), _vm._v(" "), _c('td', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Thomas Steel")])])]), _vm._v(" "), _c('td', {
    staticClass: "border1"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("Bernard Wogan")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bordera"
  }, [_c('p', {
    staticClass: "tab"
  }, [_c('span', {
    staticClass: "underline"
  }, [_vm._v("George Yates")])])]), _vm._v(" "), _c('td', {
    staticClass: "bordera"
  }, [_c('p', {
    staticClass: "tab1"
  })]), _vm._v(" "), _c('td', {
    staticClass: "border2"
  }, [_c('p', {
    staticClass: "tab1"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0022-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Top of the shaft in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Illustrated London News")]), _vm._v(". (Courtesy of Barnsley Archives)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Illustrated London News")]), _vm._v(" sent an artist to Barnsley to produce drawings of the scene to accompany its description of the explosion, the aftermath and its cause, in its edition of 13 March 1847. ‘On Tuesday morning the pit was very full of sulphur, and in the evening it was impossible to descend. At that time there remained in the pit three individuals, Abraham Matthews, John Wroe, and William Walton.’ Abraham and William had been working close to James Whiteley and his two sons; they all perished.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("J.D. Barker esquire, "), _c('span', {
    attrs: {
      "href": "#/xhtml/72_Glossary#glo4",
      "id": "sglo4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("deputy")]), _vm._v(" coroner, opened the inquest at the nearby White Bear Inn, Hoyle Mill, on Monday 8 March. The jury were sworn in and viewed about sixty-four bodies of the victims who had been brought out, before adjourning to the Court House in Barnsley. The names of the fifteen men on the jury were listed in some of the newspapers with a transcript of the inquest:")]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "tab"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("Edward Bromley")])]), _vm._v(" "), _c('td', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Jonathan Carneley")])]), _vm._v(" "), _c('td', {
    staticClass: "border1"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("John Gelder")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("John Harrison")])]), _vm._v(" "), _c('td', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Timothy Hepworth")])]), _vm._v(" "), _c('td', {
    staticClass: "border1"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("W.J. Hindle")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("George Johnson")])]), _vm._v(" "), _c('td', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Rev. Alfred Lambert")])]), _vm._v(" "), _c('td', {
    staticClass: "border1"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("Edward Parker (foreman)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("Rodgers")])]), _vm._v(" "), _c('td', {
    staticClass: "border"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("John Scales")])]), _vm._v(" "), _c('td', {
    staticClass: "border1"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("George Scorah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "bordera"
  }, [_c('p', {
    staticClass: "tab"
  }, [_vm._v("James Taylor")])]), _vm._v(" "), _c('td', {
    staticClass: "bordera"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("William Wood")])]), _vm._v(" "), _c('td', {
    staticClass: "border2"
  }, [_c('p', {
    staticClass: "tab1"
  }, [_vm._v("William Wordsworth, junior")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The inquest continued the following day to view four more bodies brought out overnight so that they might be interred without delay. It was then adjourned to 16 March so that ‘the mine might be viewed and other evidence elicited’. After listening to the testimony of managers, survivors and experts brought in to inspect the pit, it became clear that the explosion was caused by William Walton using a candle, but the verdict was ‘Accidental Death’. The jury added ‘that efficient regulations are not enforced in the district to prevent the use of naked lights in those parts of coal mines where inflammable gas is known to exist’, and they forwarded their verdict to the government in the hope that it would review the regulations to prevent such accidents recurring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most of the funerals took place on the afternoon of Monday 8 March. Forty-five men and boys were conveyed – some carried in the usual way and others on a dray – in a mile-long procession to St Mary the Virgin’s Church in Barnsley town centre. ‘Two of the graves were made to hold about 18 bodies each. There were likewise two small graves, for the remaining 8. … The other bodies were conveyed to the church yards at Ardsley, Worsbro’, Darton, and Tankersley.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Parish registers confirm that the victims were buried in churchyards at St Mary the Virgin, Barnsley (45), Christ Church, Ardsley (14), All Saints, Darton (4), St George, Barnsley (3), St Mary, Worsbrough (3), St Peter, Tankersley (2), All Saints, Darfield (1) and St Paul, Monk Bretton (1).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The parish registers for St Mary’s highlight the victims by the addition of two vertical lines at the side of the pages, and a separate typed list of all seventy-three killed in ‘Explosion at Oaks Pit, Ardsley’ was attached. The Vicar of All Saints’ Church, Darton, wrote underneath the four names in the parish registers: ‘The above from more of the numbers of the unfortunate 73 persons who lost their lives in the Oaks "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("coal mine at Ardsley on the fifth Inst: Friday last about three o’clock in the afternoon.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The churchyard was extended in 1823 and closed in 1859. After a period of neglect, it was tidied up in the 1970s with undamaged headstones being laid round the edge of four lawns in what became Churchfields Peace Gardens. Noticeboards in the public gardens explain the history of the site, there is a plan of surviving headstones and a list of individuals interred; their bodies remain here.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Newspapers claimed that the colliery proprietors had ‘done all they could to comfort and console the widows and children of the deceased and defrayed the expenses of the coffins and interments’. There was no legal requirement for colliery owners then to provide any financial assistance to their employees following accidents at work.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0024-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Funeral at St Mary’s in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Illustrated London News")]), _vm._v(". (Courtesy of Barnsley Archives)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-188bed56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/12_Chapter06.vue
// module id = 93
// module chunks = 0